export default __webpack_public_path__ + "static/Lutein-Complex-home-@1x-2110c54bc448ef06421720a51ac3ed30.jpg";